import { Login } from "../pages/Login";

export const publicRoutes = [
    {
        path: "/",
        element: Login,
    },
];
